/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Content from '@component/common/content';
import * as size from '@constant/size';
import * as color from '@constant/color';
import Scroll from '@component/common/scroll';
import ImageBlock from '@component/common/block/image-block';
import TextBlock from 'component/common/block/text-block';
import otterLandingLogoImg from '@asset/image/otter-landing-logo.webp';
import Gap from '@component/common/gap';
import { useAuthPage } from '@hook/auth/useAuth';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { useNavigate } from 'react-router-dom';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';
import { AUTH_PATH } from '@constant/auth/route-path';

const LandingBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${color.BROWN_4};
`;

const CopyWriteContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const Footer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 50px;
  background-color: ${color.BLACK_2};
  padding: 0 0 0 ${size.MARGIN_2};
`;

const TermLink = styled.a`
  font-size: small;
  color: ${color.GRAY_2};
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Landing: React.FC = () => {
  const { openAuthPage } = useAuthPage();
  const navigate = useNavigate();

  const handleStartClick = () => openAuthPage('signin');

  return (
    <>
      <Content top='0px' bottom='0px'>
        <Scroll direction='y' height={`calc(100% - 0px)`}>
          <LandingBackground>
            <Gap height={size.MARGIN_5} />
            <CopyWriteContainer>
              <TextBlock
                text={'당신의 뉴스레터,'}
                design={{ text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'big' : 'huge', bold: true } }}
              />
              <Gap height={size.MARGIN_1} />
              <TextBlock
                text={'한곳에서 정리하세요'}
                design={{ text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'big' : 'huge', bold: true } }}
              />
              <Gap height={size.MARGIN_3} />
              <TextBlock text={'매일 쌓이는 구독 메일'} design={{ text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'large' : 'big' } }} />
              <div
                css={css`
                  display: flex;
                  flex-flow: row nowrap;
                  justify-content: flex-start;
                  align-items: center;
                `}>
                <TextBlock text={'Moashelf'} design={{ text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'large' : 'big', bold: true } }} />
                <TextBlock text={'가 모아드립니다.'} design={{ text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'large' : 'big' } }} />
              </div>
            </CopyWriteContainer>
            <Gap height={size.MARGIN_5} />
            <ImageBlock
              src={otterLandingLogoImg}
              alt='back'
              design={{ image: { height: IS_IYAGIGO_MOBILE_VIEW ? '200px' : '300px' } }}
            />
            <TextBlock
              text='지금 시작하기'
              design={{
                box: {
                  width: IS_IYAGIGO_MOBILE_VIEW ? '240px' : '350px',
                  height: IS_IYAGIGO_MOBILE_VIEW ? '50px' : '65px',
                  backgroundColor: color.BROWN_1,
                  borderRadius: size.BORDER_RADIUS_2,
                  event: { cursor: 'pointer' },
                  margin: '0 auto 0 auto',
                  // transform: `translate(0, -${size.MARGIN_1})`,
                },
                text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'large' : 'big', color: color.BROWN_4 },
              }}
              click={{ handler: handleStartClick }}
            />
          </LandingBackground>
          <Footer>
            <TermLink href={AUTH_PATH.SERVICE_TERM_PATH}>서비스이용약관</TermLink>
            <Gap width={'30px'} />
            <TermLink href={AUTH_PATH.PRIVATE_TERM_PATH}>개인정보처리방침</TermLink>
          </Footer>
        </Scroll>
      </Content>
    </>
  );
};

export default Landing;
